<template>
  <div class="page-module-wrap">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <span class="label" style="font-size: 18px;margin-bottom: 30px;">1.创建</span>
          </div>
          <div class="section-gap">
            <div class="container">
              <div class="control">
                <label class="label inline-block r-top">活动名称：</label>
                <span class="r-top">{{timeLimitInfo.name}}</span>
              </div>
            </div>
            <div class="container">
              <div class="control">
                <label class="label inline-block r-top">活动类型：</label>
                <span class="r-top">{{timeLimitInfo.type | getTypeDec}}</span>
              </div>
            </div>
            <div class="container">
              <div class="control">
                <label class="label inline-block r-top">开始时间：</label>
                <span class="r-top">{{timeLimitInfo.startTime}}</span>
              </div>
            </div>
            <div class="container">
              <div class="control">
                <label class="label inline-block r-top">结束时间：</label>
                <span class="r-top">{{timeLimitInfo.endTime}}</span>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <span class="label" style="font-size: 18px;margin-bottom: 30px;">2.添加商品</span>
          </div>
          <div class="section-gap">
            <label class="label inline-block r-top fleft">商品ID：</label>
            <div class="container fleft">
                <div style="width: 500px;">
                  <textarea class="textarea" style="height: 150px;" placeholder="输入商品ID,多个ID换行" v-model="goodsIds"></textarea>
                </div>
            </div>
            <button class="button is-info btn-add fleft" @click="onAddGoods" :class="{'is-disabled':timeLimitInfo.handleType == 3}">添加</button>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <span class="label" style="font-size: 18px;margin-bottom: 30px;">3.设置折扣</span>
          </div>
          <div class="section-gap">
            <div class="block" v-if="timeLimitInfo.handleType != 3">
              <label class="label inline-block r-top">设置统一折扣：</label>
              <input type="number" class="input cyzs-w-200" v-model="allDiscount">
              <button class="button is-info" @click="setAllDiscount">设置</button>
              <span class="r-top">（商品折扣为0~10之间的数字，小数点后保留四位。折扣价格不能高于商品现价）</span>
            </div>
            <goods-sku :goods-data="goodsData"
                       :list="list" 
                       :handle-type="timeLimitInfo.handleType" 
                       :id="timeLimitInfo.timeLimitId"
                       ref="updateAll"></goods-sku>
            <div class="block">
              <button class="button is-success" @click="onSubmit" v-if="timeLimitInfo.handleType != 3">提交</button>
              <router-link :to="{name:'showTimeLimit'}" class="button is-info">返回</router-link>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import goodsSku from './goods-sku.vue'
  export default {
    components:{
      goodsSku
    },
    mounted(){
      this.timeLimitInfo = JSON.parse(this.$route.query.params)
      if(this.timeLimitInfo.handleType != 1){
        this.getList()
      }
    },
    data(){
      return {
        timeLimitInfo:{},
        goodsIds:'',
        goodsData:[],
        goodsIdsCache:[],
        list:[],
        allDiscount:''
      }
    },
    methods:{
      /**
       * 获取已经存在的限时折扣商品
       */
      getList(){
        let params = {
          timeLimitId:this.timeLimitInfo.timeLimitId,
          isReturnSku:1
        }
        HttpRequest.post('/admin.php?method=timelimit.getTimelimitDetail',params).then(response => {
          response.data.discount = ''
          response.data.goodsList = _.toArray(response.data.goodsList)
          _.each(response.data.goodsList,(goodItem)=>{
            _.each(goodItem.skuList,skuItem => {
              if(!skuItem.discount){
                skuItem.discount = goodItem.discount
              }
            })
          })
          this.goodsData = [response.data]
        })
      },
      /**
       * 根据商品ID添加商品
       */
      onAddGoods(){
        if(!this.goodsIds.trim().length){
          this.$message('商品ID不能为空！')
          return false
        }
        let goodsIdArr = this.goodsIds.split('\n'),
            params = {
              goodsList:goodsIdArr
            };
        HttpRequest.post('/admin.php?method=timelimit.getMultiGoodsSkuInfo',params).then(response => {
          _.each(response.data,(businessItem,businessIndex)=>{
            businessItem.discount = ''
            _.each(businessItem.goodsList,(goodItem,goodIndex)=>{
              goodItem.discount = ''
              goodItem.discountPrice = ''
              goodItem.skuCount = _.size(goodItem.skuList)
              _.each(goodItem.skuList,(skuItem,skuIndex)=>{
                skuItem.discount = ''
                skuItem.discountPrice = ''
              })
            })
          })
          if(this.timeLimitInfo.handleType != 1){//当前不是新建操作，需要检查添加的商品是否属于当前商家
            let currUserId = this.goodsData[0].userInfo.userId,
                currUsername = this.goodsData[0].userInfo.userName
            if(!response.data[currUserId]){
              this.$message(`当前没有属于商家【${currUsername}】的商品！`)
              this.goodsIds = ""
              return false;
            }
            this.goodsData = [response.data[currUserId]]
            this.goodsIds = ""
            if(_.size(response.data) > 1){
              this.$message(`当前存在不属于商家【${currUsername}】的商品，已过滤`,2000)
            }
          }else{
            this.goodsData = _.toArray(response.data)
            this.goodsIds = ""
          }
        })
      },
      /**
       * 保存
       */
      onSubmit(){
        let goodsList = [],params = {},ajaxUrl = '';
        _.each(this.list,(item,index)=>{
          _.each(item.goodsList,(goodItem,goodIndex)=>{
            let skuList = []
            _.each(goodItem.skuList,(skuItem,skuIndex)=>{
              skuList.push({
                skuId:skuItem.skuId,
                discount:skuItem.discount
              })
            })
            goodsList.push({
              discount:goodItem.discount,
              goodsId:goodItem.goodsId,
              price:goodItem.discountPrice,
              skus:skuList
            })
          })
        })
        if(this.goodsIds.length){
          this.$message('请先点击【添加】添加商品!',1000)
          return false
        }
        if(!goodsList.length){
          this.$message('请先添加商品再进行提交!')
          return false
        }
        if(this.timeLimitInfo.handleType == 1){ //1:新建   2:编辑
          params = {
            type:this.timeLimitInfo.type,
            name:this.timeLimitInfo.name,
            startTime:this.timeLimitInfo.startTime,
            endTime:this.timeLimitInfo.endTime,
            items:JSON.stringify(goodsList)
          }
          ajaxUrl = '/admin.php?method=timelimit.doSubmitTimelimit'
        }else{
          params = {
            timeLimitId:this.timeLimitInfo.timeLimitId,
            goodsList:JSON.stringify(goodsList)
          }
          ajaxUrl = '/admin.php?method=timelimit.doSaveGoods'
        }
        HttpRequest.post(ajaxUrl,params).then(response => {
          if(response.data.success){
            this.$message("保存成功！",1000)
            if(this.timeLimitInfo.handleType == 1){
              // debugger
              this.$router.push('/innerGoods/showTimeLimit')
            }
          }
        })
      },
      /**
       * 设置统一折扣
       */
      setAllDiscount(){
        _.each(this.list,(item,index)=>{
          _.each(item.goodsList,(goodItem,goodIndex)=>{
            goodItem.discount = this.allDiscount
          })
        })
        this.$refs.updateAll.UPDATE_ALL_DISCOUNT(this.list)
        this.allDiscount = ''
      }
    },
    filters:{
      getTypeDec(type){
        if(type == '1'){
          return '单品'
        }else if(type == '2'){
          return '搭配'
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .page-module-wrap {
    .list-wrap {
      .container {
        display: block;
        margin: 0;
        &:not(:last-child){
          margin-bottom: 5px;
        }
      }
      .btn-add {
        margin-left: 20px;
      }
    }
  }
</style>
